import React, { memo } from 'react';

import { TableView } from '@sravni/react-design-system';
import { useStyles } from '@sravni/react-utils';

import { makeHandleRowClick } from '@components/RatingTable/helpers/makeHandleRowClick';

import type { Row } from '@tanstack/react-table';

import { useFilters } from '../../../../../../store/hooks/filters';
import { useProducts } from '../../../../../../store/hooks/productPopupInfo';
import type { OrganizationRatingItem, ProductRatingItem } from '../../../../../../types/rating';
import styles from '../../table.module.scss';

type TTBodyProps = {
  rows: Array<Row<OrganizationRatingItem | ProductRatingItem>>;
  setProduct: (product: any) => void;
  setProductPopupVisibility: { on: () => void; off: () => void; toggle: () => void };
  canShowProductPopup: boolean;
};

export const TBody = memo<TTBodyProps>(({ rows, setProduct, setProductPopupVisibility, canShowProductPopup }) => {
  const cx = useStyles(styles);
  const products = useProducts();
  const filters = useFilters();

  const handleRowClick = (row: Row<OrganizationRatingItem | ProductRatingItem>) =>
    makeHandleRowClick({
      row,
      filters,
      products,
      setProduct,
      setProductPopupVisibility,
      canShowProductPopup,
    });

  return (
    <tbody>
      {rows.map((row) => (
        <TableView.Row key={`${row.id}-row`} row={row} className={cx('row')} onClick={handleRowClick(row)} />
      ))}
    </tbody>
  );
});
